import React from 'react'
import Logo from '../../Assets/imges/Logo.png'
import './Loading.scss'

export default function Loading() {
    return (
        <div className='Loading'>
            <img src={Logo} alt="Loading" />
        </div>
    )
}
